import { sva } from "@agapi/ui/panda/css";
export const textFieldStyles = sva({
    slots: ['root', 'label', 'icon', 'input', 'helper'],
    base: {
        root: {
            pt: '4',
            gap: '0',
            position: 'relative',
            width: '100%',
            my: '2',
            color: 'text.body'
        },
        label: {
            position: 'absolute',
            transition: '0.15s ease',
            transformOrigin: 'left',
            zIndex: '9',
            top: '4',
            left: '4',
            pointerEvents: "none",
        },
        icon: {
            position: 'absolute',
            mx: '3',
            top: '50%',
            transform: 'translateY(-50%)',
            pointerEvents: 'none',
            "& svg": {
                width: 'items.md',
                height: 'items.md'
            }
        },
        input: {
            p: '4',
            rounded: 'forms',
            transition: '0.25s ease-out',
            fontFamily: 'body',
            bg: 'surface.default.background',
            outlineWidth: '1px',
            outlineStyle: 'solid',
            outlineColor: 'borders.base',
            outlineOffset: '-1px',
            width: '100%',
            _focus: {
                outlineColor: 'forms.action'
            },
            _hover: {
                outlineColor: 'forms.action'
            }
        },
        helper: {
            px: 4,
            mt: 1,
            color: 'text.helper',
            lineHeight: 'none',
            fontSize: "sm",
        }
    },
    variants: {
        hideLabel: {
            true: {}
        },
        success: {
            true: {
                root: { color: 'feedback.success.foreground' },
                input: {
                    outlineWidth: '1px',
                    outlineStyle: 'solid',
                    outlineColor: 'feedback.success.border',
                    outlineOffset: '-1px',
                    bg: 'feedback.success.background',
                    _groupHover: {
                        outlineColor: 'feedback.success.border'
                    },
                    _focus: {
                        outlineColor: 'feedback.success.border'
                    }
                },
                helper: {
                    color: 'feedback.success.foreground'
                }
            }
        },
        error: {
            true: {
                root: { color: 'feedback.error.foreground' },
                input: {
                    outlineWidth: '1px',
                    outlineStyle: 'solid',
                    outlineOffset: '-1px',
                    bg: 'feedback.error.background',
                    outlineColor: 'feedback.error.border',
                    _groupHover: {
                        outlineColor: 'feedback.error.border'
                    },
                    _hover: {
                        outlineColor: 'feedback.error.border'
                    },
                    _focus: {
                        outlineColor: 'feedback.error.border'
                    }
                },
                helper: {
                    color: 'feedback.error.foreground'
                }
            }
        },
        disabled: {
            true: {
                root: { color: 'action.disabled.foreground' },
                input: {
                    outlineWidth: '1px',
                    outlineStyle: 'solid',
                    outlineColor: 'action.disabled.foreground',
                    outlineOffset: '-1px',
                    bg: 'action.disabled.background'
                },
                helper: {
                    color: 'action.disabled.foreground'
                }
            }
        },
        floatingLabel: {
            true: {
                root: {
                    '& input:focus ~ label, & input:not(:placeholder-shown) ~ label': {
                        top: '-25px',
                        left: '4',
                        transform: 'scale(0.79)',
                        transition: '0.15s ease'
                    }
                },
                label: {
                    position: 'absolute',
                    top: '50%',
                    left: '4',
                    transform: 'translateY(-50%)',
                    cursor: 'text',
                    pointerEvents: 'none'
                },
                input: {
                    '&::placeholder': {
                        opacity: 0,
                        transition: 'opacity 0.15s ease'
                    },
                    '&:focus::placeholder': {
                        opacity: 1
                    }
                }
            },
            false: {
                label: {
                    top: '-25px',
                    left: '4',
                    transform: 'scale(0.79)',
                    transition: '0.15s ease'
                }
            }
        },
        leadingIcon: {
            true: {
                label: {
                    left: '6'
                },
                input: {
                    pl: '6'
                }
            }
        },
        trailingIcon: {
            true: {
                input: {
                    pr: '6',
                }
            }
        }
    },
    compoundVariants: [
        {
            floatingLabel: false,
            leadingIcon: true,
            css: {
                label: {
                    left: '4'
                }
            }
        },
        {
            hideLabel: true,
            floatingLabel: true,
            css: {
                root: {
                    pt: '0'
                },
                input: {
                    "&:focus ~ label, &:not(:placeholder-shown) ~ label": {
                        opacity: 0,
                        top: '4!',
                        left: '5!',
                        cursor: 'text'
                    }
                }
            }
        },
        {
            hideLabel: true,
            floatingLabel: true,
            leadingIcon: true,
            css: {
                label: {
                    left: '6'
                }
            }
        }
    ]
});
